// extracted by mini-css-extract-plugin
export default {"initialWrapper":"Initial_initialWrapper__yei0v","initialTxt":"Initial_initialTxt__uVf5g"};